import { gql } from '@apollo/client';
import { PaymentSource } from '../../../constants';
import { CART_FRAGMENT, CartVersion, Cart } from '../cart.rest';

export enum CartUpdateAction {
  Gift = 'promotion',
  Reward = 'mo_rewards',
  ShippingAddress = 'address',
  ShippingMethod = 'shipping_packaging',
  PaymentMethod = 'payment_method',
  PaymentSource = 'payment_source',
  SiteCredit = 'site_credit'
}

export enum CartUpdatePropertyName {
  Gift = 'promotion_code',
  Reward = 'use_loyalty_rewards',
  CountryCode = 'country_code',
  ShippingAddress = 'address_id',
  ShippingMethod = 'shipment_method',
  PaymentMethod = 'payment_id',
  PaymentSource = 'payment_source',
  SiteCredit = 'site_credit_amount'
}

export type UpdateCartMutationAttributes = Partial<{
  id: string;
  [CartUpdatePropertyName.ShippingAddress]: string;
  [CartUpdatePropertyName.Gift]: string | null;
  [CartUpdatePropertyName.Reward]: number | null;
  [CartUpdatePropertyName.CountryCode]: string | null;
  [CartUpdatePropertyName.ShippingMethod]: number;
  [CartUpdatePropertyName.PaymentMethod]: string | null;
  [CartUpdatePropertyName.PaymentSource]: PaymentSource;
  [CartUpdatePropertyName.SiteCredit]: number;
}>;

type UpdateCartMutationVariablesInputData = {
  action_type: CartUpdateAction;
  attributes: UpdateCartMutationAttributes;
  id: string;
  type: 'carts';
};

type UpdateCartMutationVariablesInput = {
  data: UpdateCartMutationVariablesInputData;
};

export type UpdateCartMutation = {
  updateCart: {
    data: Cart[];
  };
};

export type UpdateCartMutationVariables = {
  id: string;
  countryCode: string;
  target: CartVersion;
  input: UpdateCartMutationVariablesInput;
};

export const UPDATE_CART_MUTATION = gql`
  mutation UpdateCartMutation(
    $id: String!
    $countryCode: String!
    $target: String!
    $input: UpdateCartMutationVariablesInput!
  ) {
    updateCart(id: $id, countryCode: $countryCode, target: $target, input: $input)
      @rest(
        type: "RestUserCart"
        endpoint: "cart"
        path: "/v3.5/cart/{args.id}?target={args.target}&country_code={args.countryCode}"
        method: "PATCH"
      ) {
      data @type(name: "RestUserCartData") {
        ...CartFragment
      }
    }
  }
  ${CART_FRAGMENT}
`;
